import { LearningCenterPage } from "./learningCenter";

export const LearningCenter = LearningCenterPage;
